import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import React from 'react';
export function SelectOppositeOption({
  value,
  onChange,
  placeholder = '全部',
  display = ['是', '否']
}) {
  return /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    options: display.map((item, index) => ({
      label: item,
      value: index + 1
    })),
    allowClear: true
  });
}